/** The Home's demo users (quick-connect) — the PURE half. Whether they appear is the Home's decision. */

import type { QuickConnectIdentity } from '@agenticprimitives/connect-client';
import { shortAddress } from './format';

export interface DemoPersona {
  handle: string;
  sa: string;
  shortSa: string;
  name: string;
  blurb: string | null;
}

const ADDRESS_RE = /^0x[0-9a-fA-F]{40}$/;

export function mapDemoPersonas(list: readonly QuickConnectIdentity[] | null | undefined): DemoPersona[] {
  if (!Array.isArray(list)) return [];
  const seen = new Set<string>();
  const out: DemoPersona[] = [];
  for (const p of list) {
    if (!p || typeof p !== 'object') continue;
    const handle = typeof p.handle === 'string' ? p.handle.trim() : '';
    const sa = typeof p.sa === 'string' ? p.sa.trim() : '';
    if (!handle || !ADDRESS_RE.test(sa)) continue;
    const key = handle.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    const address = sa.toLowerCase();
    out.push({ handle, sa: address, shortSa: shortAddress(address), name: typeof p.name === 'string' && p.name.trim() ? p.name.trim() : handle, blurb: typeof p.blurb === 'string' && p.blurb.trim() ? p.blurb.trim() : null });
  }
  return out;
}

export const DEMO_NOT_ENABLED = 'Demo sign-in is not enabled for this app yet — the Home has not registered OncoCoach for its demo users. Sign in with your own Home instead.';

export function describeDemoError(e: unknown): string {
  const msg = e instanceof Error ? e.message : typeof e === 'string' ? e : '';
  if (/registered client_id/i.test(msg)) return DEMO_NOT_ENABLED;
  if (/not a trusted issuer/i.test(msg)) return 'OncoCoach does not trust that Home, so a demo sign-in cannot be completed on this deployment.';
  if (/failed to fetch|networkerror|load failed/i.test(msg)) return 'Could not reach the Home to connect as that demo user.';
  return msg ? `Could not connect as that demo user — ${msg}` : 'Could not connect as that demo user.';
}
